import { AmountDistributionDTO, CategoryDistributionWrapper } from "./AmountDistributionDTO";
import { DistributionRequestDTO } from "./DistributionRequestDTO";

export class ExportRequestDTO{
  distributionTableUniqueCode: string;
  distributionRequests: DistributionRequestDTO[];
  amountDistributions: AmountDistributionDTO[];
  lenderDistributions: CategoryDistributionWrapper[];
}